import { TextField } from '@mui/material';
import { Controller } from 'react-hook-form';
import React from 'react';
import { get } from 'lodash';

const CustomNumberInput = ({ control, name, label, errors, readOnly }) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <TextField
          label={label}
          variant="outlined"
          fullWidth
          type="number"
          name={name}
          id={name}
          {...field}
          error={!!errors[name]}
          helperText={get(errors, name, {}).message}
          InputProps={{ readOnly }}
          onFocus={() => {
            if (!readOnly && field.value === 0) {
              field.onChange('');
            }
          }}
          onBlur={() => {
            if (field.value) {
              const trimmedValue = parseFloat(field.value);
              field.onChange(trimmedValue);
            }
          }}
          onChange={(event) => {
            const inputValue = event.target.value;
            if (/^\d*\.?\d{0,8}$/.test(inputValue) || inputValue === '') {
              field.onChange(inputValue);
            }
          }}
        />
      )}
    />
  );
};

export default CustomNumberInput;
